import request from '@/config/axios'

/** ==================== 文章分类 ==================== */

/** 文章分类 VO */
export interface ArticleCategoryVo {
  id?: number
  name: string
  sort?: number
  status?: number
  createTime?: Date
}

/** 分类分页查询参数 */
export interface ArticleCategoryPageParams {
  pageNo?: number
  pageSize?: number
  name?: string
  status?: number
}

/** 分类精简项（文章表单下拉） */
export interface ArticleCategorySimpleVo {
  id: number
  name: string
}

export const ArticleCategoryApi = {
  // 查询文章分类分页
  getCategoryPage: (params: ArticleCategoryPageParams) => {
    return request.get({ url: '/xuanxue/article-category/page', params })
  },
  // 获得启用分类精简列表（文章表单下拉）
  getSimpleCategoryList: () => {
    return request.get({ url: '/xuanxue/article-category/simple-list' })
  },
  // 新增文章分类
  createCategory: (data: ArticleCategoryVo) => {
    return request.post({ url: '/xuanxue/article-category/create', data })
  },
  // 修改文章分类
  updateCategory: (data: ArticleCategoryVo) => {
    return request.put({ url: '/xuanxue/article-category/update', data })
  },
  // 修改分类状态（启用/停用）
  updateCategoryStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/article-category/update-status', params: { id, status } })
  },
  // 删除文章分类（分类下存在文章时后端拒绝）
  deleteCategory: (id: number) => {
    return request.delete({ url: '/xuanxue/article-category/delete?id=' + id })
  }
}

/** ==================== 文章 ==================== */

/** 文章 VO */
export interface ArticleVo {
  id?: number
  categoryId?: number
  categoryName?: string
  title: string
  coverUrl?: string
  content: string
  sort?: number
  status?: number
  readCount?: number
  createTime?: Date
}

/** 文章分页查询参数 */
export interface ArticlePageParams {
  pageNo?: number
  pageSize?: number
  title?: string
  categoryId?: number
  status?: number
}

export const ArticleApi = {
  // 查询文章分页
  getArticlePage: (params: ArticlePageParams) => {
    return request.get({ url: '/xuanxue/article/page', params })
  },
  // 查询文章详情
  getArticle: (id: number) => {
    return request.get({ url: '/xuanxue/article/get?id=' + id })
  },
  // 新增文章
  createArticle: (data: ArticleVo) => {
    return request.post({ url: '/xuanxue/article/create', data })
  },
  // 修改文章
  updateArticle: (data: ArticleVo) => {
    return request.put({ url: '/xuanxue/article/update', data })
  },
  // 修改文章状态（上架/下架）
  updateArticleStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/article/update-status', params: { id, status } })
  },
  // 删除文章
  deleteArticle: (id: number) => {
    return request.delete({ url: '/xuanxue/article/delete?id=' + id })
  }
}
